import { render, staticRenderFns } from "./CallbackPage.vue?vue&type=template&id=23e156a7&scoped=true&"
import script from "./CallbackPage.vue?vue&type=script&lang=ts&"
export * from "./CallbackPage.vue?vue&type=script&lang=ts&"
import style0 from "./CallbackPage.vue?vue&type=style&index=0&id=23e156a7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e156a7",
  null
  
)

export default component.exports